module.exports = __webpack_public_path__ + "assets/img/53@3x.dfc1b108.png";